// import he from 'he';
export const getScreenSize = () => {
  const width = window.innerWidth;
  if (width < 480) {
    return 'mobile';
  } else if (width >= 480 && width <= 768) {
    return 'tablet';
  } else if (width > 768) {
    return 'desktop';
  }

  return null;
};

// export const removeHtmlString = (htmlString: string) => {
//   const unescapedHtml = he.decode(htmlString);
//   const plainText = unescapedHtml.replace(/<[^>]*>/g, '');

//   return plainText;
// };

export const arraysAreEqual = (array1: Array<any>, array2: Array<any>) => {
  return JSON.stringify(array1) === JSON.stringify(array2);
};

//https://stackoverflow.com/a/49448231
type BROWSER_ENUM =
  'EDGE' |
  'INTERNET_EXPLORER' |
  'FIRE_FOX' |
  'OPERA' |
  'UC_BROWSER' |
  'SAMSUNG_BROWSER' |
  'CHROME' |
  'SAFARI' |
  'UNKNOWN';


const testUserAgent = (regexp: RegExp): boolean => regexp.test(window.navigator.userAgent);

export function detectBrowser(): BROWSER_ENUM {
  switch (true) {
    case testUserAgent(/edg/i): return 'EDGE';
    case testUserAgent(/trident/i): return 'INTERNET_EXPLORER';
    case testUserAgent(/firefox|fxios/i): return 'FIRE_FOX';
    case testUserAgent(/opr\//i): return 'OPERA';
    case testUserAgent(/ucbrowser/i): return 'UC_BROWSER';
    case testUserAgent(/samsungbrowser/i): return 'SAMSUNG_BROWSER';
    case testUserAgent(/chrome|chromium|crios/i): return 'CHROME';
    case testUserAgent(/safari/i): return 'SAFARI';
    default: return 'UNKNOWN';
  }
}

export const checkLang = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const langParam = urlParams.get('lang');

  return langParam == 'zh-hans' ? 'zh-hans' : 'en';
};

import axios from 'axios';
import { ref } from 'vue';
import { WorkResponse } from '../model/interfaces/WorkInterface';

export function useTimer(
  duration: number, // Timer duration in seconds
  onComplete: () => void // Callback to trigger when the timer completes
) {
  const timeRemaining = ref(duration);
  const timerInterval = ref<number | null>(null);
  const isRunning = ref(false);

  // Computed properties for minutes and seconds
  const minutes = ref(Math.floor(timeRemaining.value / 60).toString().padStart(2, '0'));
  const seconds = ref((timeRemaining.value % 60).toString().padStart(2, '0'));

  // Function to start the timer
  const startTimer = () => {
    if (isRunning.value) return; // Prevent multiple intervals
    isRunning.value = true;

    timerInterval.value = setInterval(() => {
      if (timeRemaining.value > 0) {
        timeRemaining.value -= 1;
        // Update minutes and seconds
        minutes.value = Math.floor(timeRemaining.value / 60).toString().padStart(2, '0');
        seconds.value = (timeRemaining.value % 60).toString().padStart(2, '0');
      } else {
        stopTimer();
        onComplete(); // Call the callback function when timer ends
      }
    }, 1000);
  };

  // Function to stop the timer
  const stopTimer = () => {
    if (timerInterval.value !== null) {
      clearInterval(timerInterval.value);
      timerInterval.value = null;
      isRunning.value = false;
    }
  };

  // Function to reset the timer
  const resetTimer = () => {
    stopTimer();
    timeRemaining.value = duration;
    minutes.value = Math.floor(timeRemaining.value / 60).toString().padStart(2, '0');
    seconds.value = (timeRemaining.value % 60).toString().padStart(2, '0');
  };

  return {
    timeRemaining,
    minutes,
    seconds,
    isRunning,
    startTimer,
    stopTimer,
    resetTimer,
  };
}

/**
 * @returns {boolean} Returns true if the user is using a mobile device
 */
export function isMobileWidth(): boolean {
  return getScreenSize() === 'mobile';
}

/**
 * Returns the current dark mode state of the document.
 */
export function getDarkMode(): boolean {
  return document.documentElement.classList.contains('dark');
}

/**
 * Watches the document's dark mode state and calls the given callback
 * whenever it changes.
 *
 * The callback is called immediately with the current dark mode state,
 * and then again whenever the state changes.
 *
 * Returns a function that can be called to disconnect the observer.
 *
 * @param {function(isDarkMode:boolean)} callback
 * @return {function()} Disconnect function
 */
export function watchDarkMode(callback: any) {
  const htmlElement = document.documentElement;

  // Check the current state initially
  const isDarkMode = htmlElement.classList.contains('dark');
  callback(isDarkMode);

  // Create a MutationObserver to monitor changes
  const observer = new MutationObserver(() => {
    const newDarkModeState = htmlElement.classList.contains('dark');
    callback(newDarkModeState);
  });

  // Observe the `<html>` element for class attribute changes
  observer.observe(htmlElement, { attributes: true, attributeFilter: ['class'] });

  // Return a function to disconnect the observer
  return () => observer.disconnect();
}

export function scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

export async function getWorks(): Promise<WorkResponse | null> {
  try {
    const response = await axios.get('/wp-json/api/v1/works');
    return response.data; // Return the data if the request succeeds
  } catch (error) {
    console.error('Error fetching works:', error);
    throw error; // Re-throw the error to handle it in the calling code
  }
}

// src/utils/orientation.js
export const setupOrientationListener = (callback: any) => {
  const updateOrientation = () => {
    const isPortrait = window.matchMedia('(orientation: portrait)').matches;
    callback(isPortrait ? 'portrait' : 'landscape');
  };

  // Add listener for orientation changes
  const orientationMediaQuery = window.matchMedia('(orientation: portrait)');
  orientationMediaQuery.addEventListener('change', updateOrientation);

  // Call the callback initially
  updateOrientation();

  // Cleanup function
  return () => {
    orientationMediaQuery.removeEventListener('change', updateOrientation);
  };
};
